<ng-container *ngIf="state$ | async as state">
    <!-- ITP-E-249-01: Play / Pause, the line that fills as it plays, and the length (the time so far while it plays).
         ITP-E-249-04: the line is the waveform, a slider that seeks; then the speed button. -->
    <div class="voice-bubble" role="group" aria-label="Voice message">
        <button type="button" class="voice-play" (click)="toggle()" [attr.aria-label]="labelOf(state)"
                [attr.aria-busy]="state.status === 'loading'">
            <i aria-hidden="true"
               [ngClass]="state.status === 'loading' ? 'fa-solid fa-spinner fa-spin' : (isPlaying(state) ? 'fa-solid fa-pause' : 'fa-solid fa-play')"></i>
        </button>
        <messenger-voice-waveform [peaks]="current?.voicePeaks" [positionMs]="state.positionMs" [lengthMs]="lengthOf(state)"
                                  label="Voice message position" (seek)="seek($event)"></messenger-voice-waveform>
        <span class="voice-time">{{timeOf(state)}}</span>
        <!-- ITP-E-249-05: someone else's voice message not played yet. -->
        <span *ngIf="isUnplayed(played$ | async)" class="voice-unplayed" role="img" aria-label="Not played yet"></span>
        <button *ngIf="speed$ | async as speed" type="button" class="voice-speed" (click)="cycleSpeed(speed)"
                [attr.aria-label]="'Playback speed ' + formatSpeed(speed)">{{formatSpeed(speed)}}</button>
    </div>
    <div *ngIf="state.status === 'error'" class="voice-note" role="status">
        <span>Could not play this voice message.</span>
        <button type="button" class="voice-link" (click)="retry()">Try again</button>
    </div>
    <div *ngIf="state.status === 'unplayable'" class="voice-note" role="status">
        <span>This browser can't play this voice message</span>
        <button type="button" class="voice-link" (click)="download()">Download</button>
    </div>
    <span *ngIf="downloadFailed" class="voice-note" role="status">This file can't be opened.</span>
</ng-container>
